// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3wMn_","select":"Header_select__3tWMX","clinic":"Header_clinic__3Qojd"};